import { FlyoutPanel, StateGroup, VariantGroup } from "../types";

import { InfoPanel } from "./InfoPanel";
import { LocalePanel } from "./LocalePanel";
import { SettingsPanel } from "./SettingsPanel";
import { SharePanel } from "./SharePanel";
import { StatesPanel } from "./StatesPanel";
import { VariantsPanel } from "./VariantsPanel";

export const PanelFlyout: React.FC<{
  selected: FlyoutPanel;
  variantGroups: VariantGroup[];
  stateGroups: StateGroup[];
  settingsGroups: VariantGroup[];
}> = ({ selected, variantGroups, stateGroups, settingsGroups }) => {
  switch (selected) {
    case "info":
      return <InfoPanel />;
    case "locale":
      return <LocalePanel />;
    case "variants":
      return <VariantsPanel variantGroups={variantGroups} />;
    case "states":
      return <StatesPanel stateGroups={stateGroups} />;
    case "settings":
      return <SettingsPanel settingsGroups={settingsGroups} />;
    case "share":
      return <SharePanel />;
    default:
      return null;
  }
};
